exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr[data-v-6e32b34e]{background-color:#2874a6}#RCDetailsModalId .modal-dialog[data-v-6e32b34e]{min-width:80%}", ""]);

// exports
